import React, { useEffect, useState, useRef, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import {
  Alert,
  Form,
  Input,
  Row,
  Col,
  Tag,
  Select,
  Button,
  Switch,
  Tooltip,
} from 'antd';
import store from '../store';
import Checkbox from './checkbox';
import Radio from './radio';
import Upload from './upload-qiniu';
import Header from './header';
import { HelperCore, HelpOther } from '@/common/helper';
import globalStore from '@/store/global';
import { SVGPureIcon } from '@ui/svg-icon';
import knowledgeChoiceStore from '@/components/knowledge-choice/store';
import client from '@/store/client';
import { useParams } from 'react-router-dom';
import CustomSwitch from './switch';
import ListItem from './list-item';
import { inputEnum } from '../constant';
import ImageCheckboxGroup from './imageCheckbox';

const { TextArea } = Input;

const FormMain = observer(({ form, visible }) => {
  const watcherServerlist = Form.useWatch('server_list', form);
  const watcherDatasetId = Form.useWatch('dataset_id', form);
  const watcherInput_func = Form.useWatch('input_func', form);

  const watcherRoleId = Form.useWatch('role_id', form);
  const [openSkill, setOpenSkill] = useState(false);
  const [openKnowledge, setOpenKnowledge] = useState(false);
  const [openModel, setOpenModel] = useState(false);
  const $skllPanel = useRef(null);
  const [showPanelSize, setShowPanelSize] = useState('large');
  const [skillDisable, setSkillDisable] = useState(false);
  const [modelDisable, setModelDisable] = useState(false);
  const [knowledgeList, setknowledgeList] = useState([]);
  const [openVisitModel, setOpenVisitModel] = useState(false);
  const watcherVisitable = Form.useWatch('visitable', form);
  const visitableOptions = useMemo(() => {
    return [
      {
        label: '公开（所有人可使用）',
        value: 1,
        id: 1,
        icon: 'https://p1.ssl.qhimg.com/t110b9a93016d1a1ea8e1187717.png',
      },
      {
        label: '公开（所有人可使用，克隆）',
        value: 4,
        id: 1,
        icon: 'https://p1.ssl.qhimg.com/t110b9a93014bff0f79c1c82578.png',
      },
      {
        label: '仅自己可见',
        value: 3,
        id: 3,
        icon: 'https://p1.ssl.qhimg.com/t110b9a9301e2d4dc2ddbb99449.png',
      },
    ];
  }, []);

  useEffect(() => {
    const maxServer = Number(store.max_server_count);
    const isSupportMcp = store.modelList?.find(
      item => item.role_id == watcherRoleId
    )?.support_mcp;

    if (watcherServerlist?.length >= maxServer || !isSupportMcp) {
      setSkillDisable(true);
    } else {
      setSkillDisable(false);
    }
  }, [
    watcherServerlist,
    store.max_server_count,
    watcherRoleId,
    store.modelList,
  ]);

  useEffect(() => {
    if (watcherServerlist && watcherServerlist.length) {
      setModelDisable(true);
    } else {
      setModelDisable(false);
    }
  }, [watcherServerlist]);

  // 合并知识库数据列表
  useEffect(() => {
    setknowledgeList([
      ...(knowledgeChoiceStore?.list_create ?? []),
      ...(knowledgeChoiceStore?.list_share ?? []),
    ]);
  }, [knowledgeChoiceStore.list_create, knowledgeChoiceStore.list_share]);

  const onGreetingChange = e => {
    const { value } = e.target;
    // 同步表单数据与store
    form.setFieldsValue({
      greeting: value,
    });
    store.setGreeting(value);
  };


  return (
    <div>
      <div className="bg-[#f7f7f7] rounded-12px px-24px py-24px">
        <div className="flex items-center mb-16px">
          {store.genLoading ? (
            <div className="w-60px flex items-center justify-center h-60px rounded-200px   mx-auto relative cursor-pointer !mr-16px">
              <div className="rotate-ele">
                <img
                  src="https://p1.ssl.qhimg.com/d/inn/8ea475776b25/nm_ag_icon_loading.png"
                  className="size-16px"
                  alt=""
                />
              </div>
            </div>
          ) : (
            <Upload
              onUpload={({ error, url, file }) => {
                if (error) {
                  return;
                }
                store.setAgentImage(url);
              }}
              className="!mx-auto !block w-60px h-60px  !mr-16px"
            >
              <div className="w-60px flex items-center justify-center h-60px rounded-200px   mx-auto relative cursor-pointer">
                {store.agentImage ? (
                  <img
                    className="size-full object-cover rounded-full overflow-hidden"
                    src={store.agentImage}
                  />
                ) : (
                  <img
                    onMouseLeave={() => {
                      store.setDefaultImage(store.defaultImage);
                    }}
                    onMouseEnter={() => {
                      store.setDefaultImage(store.defaultHoverImage);
                    }}
                    className="size-full object-cover rounded-full overflow-hidden"
                    src={store.currentImage}
                  />
                )}
              </div>
            </Upload>
          )}

          <Form.Item className="flex-1 disable-input !mb-0 title" name="title">
            <Input
              disabled={store.genLoading}
              style={{ height: 40 }}
              className="!text-14px"
              size="large"
              placeholder="输入智能体名称"
            />
          </Form.Item>
          <div
            onClick={() => {
              const title = form.getFieldValue('title');

              if (!title?.trim()) {
                HelpOther.toast('请输入智能体名称！');
                return;
              }
              if (store.genLoading || store.disableGened) {
                return;
              }
              if (store.greeting && store.agentImage) {
                HelpOther.confirm({
                  title: '确认删除历史记录?',
                  okText: '自动生成',
                  content: (
                    <div className="whitespace-nowrap">
                      头像、欢迎语将会被生成的内容覆盖，且无法撤销
                    </div>
                  ),
                  onOk: () => {
                    store.genFormContent(title, true);
                  },
                });
                return;
              }
              store.genFormContent(title);
            }}
            style={{
              opacity: store.genLoading || store.disableGened ? '0.5' : '1',
              background:
                'linear-gradient(90deg, rgba(31, 188, 248, 0.08) 30.1%, rgba(0, 106, 255, 0.08) 100%)',
              // backgroundClip: 'text',
              // WebkitTextFillColor: 'transparent'
            }}
            className="items-center inline-flex px-12px py-4px text-14px font-medium rounded-14px ml-14px ai-generator"
          >
            <img
              className="w-20px mr-6px"
              src="https://p1.ssl.qhimg.com/t110b9a9301dd287ed33d1e2483.png"
            />
            <span
              style={{
                background:
                  'linear-gradient(90deg, #26D0F6 -39.29%, #006AFF 100%)',
                backgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
              }}
            >
              {store.genLoading ? '生成中...' : '一键完善'}
            </span>
          </div>
        </div>

        <Form.Item
          className="disable-input space-b-0"
          label="欢迎语"
          name="greeting"
        >
          <Input
            style={{ height: 40 }}
            className="!text-14px "
            size="large"
            disabled={store.genLoading}
            onChange={onGreetingChange}
            placeholder={
              store.genLoading
                ? '正在生成中...'
                : '介绍智能体的功能，将会展示给智能体的用户。'
            }
          />
        </Form.Item>
      </div>

      <div className="bg-[#f7f7f7] rounded-12px px-24px py-24px mt-12px">
        <Form.Item
          className="relative position-dropdown-access space-b-0"
          label={
            <div className="!text-14px font-medium text-[#000] !leading-20px">
              <div>使用权限</div>
            </div>
          }
          name="visitable"
        >
          <Select
            className="!text-14px custom-select"
            placement="bottomLeft"
            onDropdownVisibleChange={visible => setOpenVisitModel(visible)}
            showSearch={false}
            mode="multiple"
            open={openVisitModel}
            onSearch={() => {}} // 空函数阻止搜索
            suffixIcon={
              <SVGPureIcon
                style={{
                  PointerEvent: 'none',
                  transform: openVisitModel ? 'rotate(180deg)' : 'rotate(0deg)',
                }}
                name="ic_more"
                className="w-12px h-8px !text-[rgba(0,0,0,0.5)]"
              />
            }
            getPopupContainer={() =>
              document.querySelector('.position-dropdown-access')
            }
            onInputKeyDown={e => {
              e.preventDefault();
              e.stopPropagation();
            }}
            options={visitableOptions}
            tagRender={props => {
              const { label, value, closable, onClose } = props;
              const item = visitableOptions.find(item => item.value == value);
              return (
                <span
                  key={value}
                  className="flex items-center ml-8px text-14px text-[#000]"
                >
                  <img className="w-20px" src={item?.icon} />
                  <span className="ml-6px">{label}</span>
                </span>
              );
            }}
            size="large"
            placeholder="权限设置"
            dropdownRender={menu => (
              <div className="">
                {/* 渲染每个选项的 Checkbox */}
                <div
                  className={`nw-scrollbar  ${showPanelSize == 'large' ? 'max-h-308px' : 'max-h-176px'}`}
                  style={{ overflowY: 'auto' }}
                >
                  {visitableOptions?.map(item => (
                    <div
                      key={item.id}
                      style={{
                        margin: '2px 6px',
                        padding: '0px 8px',
                        flex: '1 1 50%',
                      }}
                      className="custom-select-wrapper cursor-pointer h-44px flex items-center box-border hover:bg-[rgba(0,0,0,0.03)] hover:rounded-8px"
                      onClick={e => {
                        e.stopPropagation();
                        const selectedValue =
                          form.getFieldValue('visitable') || '';
                        if (selectedValue != item.value) {
                          form.setFieldsValue({
                            visitable: item.value,
                          });
                        }
                        setOpenVisitModel(false);
                      }}
                    >
                      <Radio
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                        }}
                        value={item?.value}
                        className="custom-checkbox-label"
                        currentValue={watcherVisitable}
                      >
                        <img src={item?.icon} className="w-20px" />
                        <span className="text-14px font-normal ml-6px">
                          {item?.label}
                        </span>
                      </Radio>
                    </div>
                  ))}
                </div>
              </div>
            )}
          />
        </Form.Item>
      </div>

      <div className="bg-[#f7f7f7] rounded-12px px-24px py-24px mt-12px">
        {/* <Form.Item label="角色介绍(prompt)" name="intro">
          <TextArea
            className="text-14px nw-scrollbar-thin"
            autoSize={{ minRows: 4, maxRows: 10 }}
            style={{
              // height: '80px',
              resize: 'none',
              padding: '10px 12px',
            }}
            placeholder="示例：你是一位经验丰富的研究员，善于在各个领域搜索数据，解读报告，并提供研究成果。"
          />
        </Form.Item> */}
        {/* <div className="flex items-center justify-between mb-16px">
          <div className="text-[#000]   flex text-14px font-medium">
            <span className='mr-3px'>创建超级智能体</span>
						<Tooltip destroyTooltipOnHide  placement="top" arrow title='开启后，为您显示高级MCP工具' >
							<span ><SVGPureIcon name='mcp_tip' className='size-16px'  /></span>
						</Tooltip>
						
          </div>
          <CustomSwitch name="super_switch" />
        </div> */}
        <Form.Item noStyle dependencies={['server_list']}>
          {({ getFieldValue }) => {
            const serverList = getFieldValue('server_list');
            let options;
            if (serverList && serverList.length) {
              options = store.modelList?.filter(item => item.support_mcp);
            } else {
              options = store.modelList;
            }
            return (
              <Form.Item
                className="relative position-dropdown-model model-form"
                label={
                  <div className="!text-14px font-medium text-[#000] !leading-20px">
                    <div>模型选择</div>
                  </div>
                }
                name="role_id"
              >
                <Select
                  className="!text-14px custom-select"
                  placement="topLeft"
                  onDropdownVisibleChange={visible => setOpenModel(visible)}
                  open={openModel}
                  suffixIcon={
                    <SVGPureIcon
                      style={{
                        PointerEvent: 'none',
                        transform: openModel
                          ? 'rotate(180deg)'
                          : 'rotate(0deg)',
                      }}
                      name="ic_more"
                      className="w-12px h-8px !text-[rgba(0,0,0,0.5)]"
                    />
                  }
                  getPopupContainer={() =>
                    document.querySelector('.position-dropdown-model')
                  }
                  options={options?.map(item => {
                    return {
                      ...item,
                      label: item.title,
                      value: item.role_id,
                    };
                  })}
                  size="large"
                  placeholder="给智能体配置知识库"
                  dropdownRender={menu => (
                    <div className="">
                      <div className="px-12px pt-14px pb-8px">
                        <div className="flex items-center justify-between pb-13px border-[rgba(0,0,0,0.06)] border-b-1px">
                          <div className="font-14px text-[#000] font-medium">
                            模型选择
                          </div>
                        </div>
                      </div>
                      <div
                        className={`nw-scrollbar  px-6px  ${showPanelSize == 'large' ? 'max-h-308px' : 'max-h-176px'}`}
                        style={{ overflowY: 'auto' }}
                      >
                        {options?.map(item => (
                          <div
                            key={item.role_id}
                            style={{ padding: '0px 8px' }}
                            onClick={e => {
                              if (modelDisable && !item.support_mcp) {
                                HelpOther.toast('当前模型不支持mcp');
                                return;
                              }
                              const selectedValue =
                                form.getFieldValue('role_id') || '';
                              if (selectedValue != item.role_id) {
                                form.setFieldsValue({
                                  role_id: item.role_id,
                                });
                              }
                              setOpenModel(false);
                            }}
                            className="custom-select-wrapper cursor-pointer flex-wrap h-44px flex items-center box-border hover:bg-[rgba(0,0,0,0.03)] hover:rounded-8px"
                          >
                            <Radio
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                              }}
                              item={item}
                              value={item.role_id}
                              className="custom-checkbox-label"
                              currentValue={watcherRoleId}
                              imgDisabled={modelDisable}
                            >
                              <img
                                src={item.icon}
                                className="w-20px rounded-100px"
                              />
                              <span
                                className={`${modelDisable && !item.support_mcp ? 'disabled' : ''} text-14px font-normal ml-6px`}
                              >
                                {item.title}
                              </span>
                              {item.support_mcp ? (
                                <span className="px-6px ml-6px rounded-4px bg-[rgba(0,88,255,0.10)] leading-18px text-[#0058ff] text-12px font-semibold">
                                  MCP
                                </span>
                              ) : null}
                            </Radio>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                />
              </Form.Item>
            );
          }}
        </Form.Item>
        <Form.Item noStyle dependencies={['role_id']}>
          {({ getFieldValue }) => {
            const roleVal = getFieldValue('role_id');
            const isSupportMcp = store.modelList.find(
              item => item.role_id == roleVal
            )?.support_mcp;
            let options = store.mcpList;

            return (
              <Form.Item
                className="relative skill-form position-dropdown"
                label={
                  <div className="!text-14px font-medium text-[#000] !leading-20px">
                    <div>
                      MCP 工具选择
                      {watcherServerlist?.length ? (
                        <span className="text-12px font-normal text-[rgba(0,0,0,0.5)]">
                          (已选{watcherServerlist?.length})
                        </span>
                      ) : null}
                    </div>
                  </div>
                }
                name="server_list"
              >
                <Select
                  size="large"
                  showSearch={false}
                  className="custom-select custom-skill-select !text-14px"
                  mode="multiple"
                  open={openSkill}
                  disabled={isSupportMcp ? false : true}
                  placement="bottomLeft"
                  onInputKeyDown={e => {
                    if (e.key !== 'Backspace' && e.key !== 'Delete') {
                      e.preventDefault();
                    }
                  }}
                  maxTagCount="responsive"
                  placeholder="智能体可以调度各种工具完成多种任务，如：爬取网页、生成音频文件等"
                  style={{
                    boxShadow: 'none',
                  }}
                  onDropdownVisibleChange={visible => setOpenSkill(visible)}
                  getPopupContainer={() =>
                    document.querySelector('.position-dropdown')
                  }
                  suffixIcon={
                    <SVGPureIcon
                      style={{
                        PointerEvent: 'none',
                        transform: openSkill
                          ? 'rotate(180deg)'
                          : 'rotate(0deg)',
                      }}
                      name="ic_more"
                      className="w-12px h-8px text-[rgba(0,0,0,0.5)]"
                    />
                  }
                  options={options}
                  tagRender={props => {
                    const { label, value, closable, onClose } = props;
                    return (
                      <span className="flex items-center justify-center h-20px ml-12px  ">
                        <span className="text-14px font-normal text-[#000] mr-4px">
                          {label}
                        </span>
                        <span
                          onClick={() => {
                            const item = store.getCurrentMcp(value) || {};
                            if (item.server_name == 'get-agent-prompt') {
                              HelpOther.toast(
                                '取消智能体提示词获取工具后，智能体将无法调用多个提示词'
                              );
                            }
                            onClose();
                          }}
                          className="flex cursor-pointer items-center justify-center w-14px h-14px rounded-100px bg-[rgba(0,0,0,0.1)]"
                        >
                          <SVGPureIcon
                            className="!text-[rgba(0,0,0,0.5)]"
                            name="modal_close "
                            size={8}
                          ></SVGPureIcon>
                        </span>
                      </span>
                    );
                  }}
                  dropdownRender={menu => (
                    <div ref={$skllPanel} className="custom-dropdown-content">
                      {/* 下拉菜单顶部可添加搜索或其他操作 */}
                      <div className="px-12px pt-14px pb-8px">
                        <div className="flex items-center justify-between pb-13px border-[rgba(0,0,0,0.06)] border-b-1px">
                          <div className="font-14px text-[#000] font-medium">
                            MCP 工具选择
                          </div>
                          <div className="font-14px text-[#006aff] cursor-pointer font-medium flex items-center">
                            <div
                              onClick={() => {
                                if (!(client.isLLQ || client.isSeLLQ)) {
                                  HelpOther.toast(
                                    '去PC端体验完整功能',
                                    'warning'
                                  );
                                  setTimeout(() => {
                                    client.openPage('/download');
                                  }, 2 * 1000);
                                  return;
                                }
                                client.openPage(
                                  client.is360se
                                    ? 'https://browser.360.cn/ai/mcpsquare-se.html'
                                    : 'https://browser.360.cn/ai/mcpsquare.html'
                                );
                              }}
                            >
                              MCP 工具箱
                            </div>
                            <SVGPureIcon
                              className="text-[#006aff]"
                              size={18}
                              name="arrows_right4"
                            />
                          </div>
                        </div>
                      </div>
                      {/* 渲染每个选项的 Checkbox */}
                      <div
                        className={`nw-scrollbar px-6px  ${showPanelSize == 'large' ? 'max-h-308px' : 'max-h-176px'}`}
                        style={{ overflowY: 'auto' }}
                      >
                        {options?.map(item => (
                          <div
                            key={item.value}
                            style={{ padding: '8px 10px', flex: '1 1 50%' }}
                            className="custom-select-wrapper h-44px cursor-pointer box-border hover:bg-[rgba(0,0,0,0.03)] hover:rounded-8px"
                            onClick={e => {
                              const selectedValues =
                                form.getFieldValue('server_list') || [];
                              if (!isSupportMcp) {
                                HelpOther.toast(
                                  '当前mcpserver不支持当前所选模型！'
                                );
                                return;
                              }

                              const cur_mcp = store.getCurrentMcp(item.value) || {};
                              if (cur_mcp.server_name == 'get-agent-prompt' && selectedValues.includes(item.value)) {
                                HelpOther.toast(
                                  '取消智能体提示词获取工具后，智能体将无法调用多个提示词'
                                );
                              }

                              if (selectedValues.includes(item.value)) {
                                form.setFieldsValue({
                                  server_list: selectedValues.filter(
                                    v => v !== item.value
                                  ),
                                });
                              } else {
                                if (skillDisable) {
                                  HelpOther.toast('选中超出最大配置');
                                  return;
                                }
                                form.setFieldsValue({
                                  server_list: [...selectedValues, item.value],
                                });
                              }
                            }}
                          >
                            <Checkbox
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                              }}
                              value={item.value}
                              server_list={watcherServerlist}
                              className={`custom-checkbox-label`}
                              imgDisabled={`${store.getSkillDisableCls(skillDisable, form.getFieldValue('server_list'), item)}`}
                              checked={form
                                .getFieldValue('server_list')
                                ?.includes(item.value)}
                            >
                              <img
                                className="w-24px rounded-100px mr-6px"
                                src={item.icon}
                              />
                              <span
                                className={`${store.getSkillDisableCls(skillDisable, form.getFieldValue('server_list'), item)} text-14px font-normal`}
                              >
                                {item.label}
                              </span>
                            </Checkbox>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                ></Select>
              </Form.Item>
            );
          }}
        </Form.Item>

        <Form.Item
          className="relative position-dropdown-knowledge space-b-0"
          label={
            <div className="!text-14px font-medium text-[#000] !leading-20px">
              <div>知识库选择</div>
            </div>
          }
          name="dataset_id"
        >
          <Select
            className="!text-14px custom-select"
            placement="topLeft"
            onDropdownVisibleChange={visible => setOpenKnowledge(visible)}
            open={openKnowledge}
            suffixIcon={
              <SVGPureIcon
                style={{
                  PointerEvent: 'none',
                  transform: openKnowledge ? 'rotate(180deg)' : 'rotate(0deg)',
                }}
                name="ic_more"
                className="w-12px h-8px !text-[rgba(0,0,0,0.5)]"
              />
            }
            getPopupContainer={() =>
              document.querySelector('.position-dropdown-knowledge')
            }
            options={knowledgeList?.map(item => {
              return {
                ...item,
                label: item.name,
                value: item.folder_id,
              };
            })}
            tagRender={props => {
              const { label, value, closable, onClose } = props;
              return (
                <span key={value} className="text-14px text-[#000]">
                  label
                </span>
              );
            }}
            size="large"
            placeholder="智能体可以使用知识库内容完成多种任务，如：基于行业专有资料生成研究报告等"
            dropdownRender={menu => (
              <div className="">
                {/* 下拉菜单顶部可添加搜索或其他操作 */}
                <div className="px-12px pt-14px pb-8px">
                  <div className="flex items-center justify-between pb-13px border-[rgba(0,0,0,0.06)] border-b-1px">
                    <div className="font-14px text-[#000] font-medium">
                      知识库选择
                    </div>
                  </div>
                </div>
                {/* 渲染每个选项的 Checkbox */}

                <div
                  className={`nw-scrollbar  ${showPanelSize == 'large' ? 'max-h-308px' : 'max-h-176px'}`}
                  style={{ overflowY: 'auto' }}
                >
                  {knowledgeChoiceStore.list_default?.length > 0 ? (
                    <>
                      <div className="px-14px mt-5px mb-7px text-14px text-[rgba(0,0,0,0.5)]">
                        选择
                      </div>
                      {knowledgeChoiceStore.list_default?.map(item => (
                        <ListItem
                          key={item.folder_id}
                          form={form}
                          item={item}
                          watcherDatasetId={watcherDatasetId}
                          setOpenKnowledge={setOpenKnowledge}
                        ></ListItem>
                      ))}
                    </>
                  ) : null}
                  {knowledgeChoiceStore.list_create?.filter(
                    item => item.is_default != 1
                  )?.length > 0 ? (
                    <>
                      <div className="px-14px mt-9px mb-7px text-14px text-[rgba(0,0,0,0.5)]">
                        我创建的知识库
                      </div>
                      {knowledgeChoiceStore.list_create
                        .filter(item => item.is_default != 1)
                        ?.map(item => (
                          <ListItem
                            key={item.folder_id}
                            form={form}
                            item={item}
                            watcherDatasetId={watcherDatasetId}
                            setOpenKnowledge={setOpenKnowledge}
                          ></ListItem>
                        ))}
                    </>
                  ) : null}

                  {knowledgeChoiceStore.list_share?.length > 0 ? (
                    <>
                      <div className="px-14px mt-9px mb-7px text-14px text-[rgba(0,0,0,0.5)]">
                        别人分享给我的知识库
                      </div>
                      {knowledgeChoiceStore.list_share?.map(item => (
                        <ListItem
                          key={item.folder_id}
                          form={form}
                          item={item}
                          watcherDatasetId={watcherDatasetId}
                          setOpenKnowledge={setOpenKnowledge}
                        ></ListItem>
                      ))}
                    </>
                  ) : null}
                </div>
              </div>
            )}
          />
        </Form.Item>
      </div>

      <div className="bg-[#f7f7f7] rounded-12px px-24px py-24px mt-12px">
        <ImageCheckboxGroup
          label="设定输入框功能（支持多选）"
          name="input_func"
          form={form}
          value={watcherInput_func}
          options={[
            {
              label: '输入问题',
              value: '1',
            },
            {
              label: '上传文件',
              value: '2',
            },
            {
              label: '上传图片',
              value: '3',
            },
          ]}
        />
        <Form.Item
          className=" space-b-0"
          label="填写输入框内提示文案"
          name="input_tip"
        >
          <Input
            placeholder="您定义的提示语将会在对话页输入框内显示，向用户说明如何与智能体对话"
            style={{ height: 40 }}
            className="!text-14px "
            size="large"
          />
        </Form.Item>
      </div>

      <div>
        <div className="bg-[#f7f7f7] rounded-12px px-24px pt-24px pb-5px mt-12px">
          
            <Form.List name="saylist_detail">
              {(fields, { add, remove }, { errors }) => (
                <>
                  {fields?.map((field, index) => {
                    return (
                      <Form.Item
                        required={false}
                        key={field.key}
                        name={field.name}
                        label={
                          index == 0 ? (
                            <div className="flex items-center add-item justify-between text-14px">
                              <div>试着问问我</div>

                              <div
                                className="text-[#006aff] hover:text-[#005ee3]"
                                onClick={() => {
                                  if (fields.length >= 4 || !watcherInput_func?.includes('1')) {
                                    return;
                                  }
                                  add();
                                }}
                              >
                                添加问题
                              </div>
                            </div>
                          ) : (
                            ''
                          )
                        }
                        className={`${index == fields.length - 1 ? 'dynamic-ask-mb' : ''} relative dynamic-ask-item`}
                      >
                        <Input
                          size="large"
                          className="!text-14px"
                          style={{ height: 40 }}
                          disabled={!watcherInput_func?.includes('1')}
                          suffix={
                            <span className="w-28px h-28px flex items-center rounded-8px justify-center block hover:bg-[rgba(0,0,0,0.06)]">
                              <SVGPureIcon
                                onClick={e => {
                                  e.stopPropagation();
                                  e.preventDefault();
                                  if (fields.length <= 1) {
                                    return;
                                  }
                                  remove(field.name);
                                }}
                                name="modal_close"
                                size={14}
                                className="text-primary-opacity text-opacity-50 hover:text-opacity-100"
                              />
                            </span>
                          }
                          allowClear={false}
                          placeholder="“您输入的使用示例将会展现在智能体对话页，并支持用户点击"
                        />
                      </Form.Item>
                    );
                  })}
                  {/* <Form.Item>
														<Form.ErrorList errors={errors} />
													</Form.Item> */}
                </>
              )}
            </Form.List>

          {/* 智能体提示词在这里 */}
          <div className="">
            <Form.Item className="disable-input space-b-0" label="定制输入界面">
              <div className="flex flex-row flex-wrap mt-5px">
                {store.prompt_form?.map((item, index) => {
                  return (
                    <div
                      className="w-200px h-40px rounded-8px border-1px border-black border-opacity-10 bg-white hover:bg-[rgba(0,0,0,.03)] cursor-pointer relative mr-10px mb-10px prompt-label"
                      key={index}
                    >
                      <p
                        className="w-200px px-12px leading-40px text-14px truncate text-center"
                        data-id={item.form_id}
                        onClick={e => {
                          store.setFormId(e.target.dataset.id);
                          store.setVisiblePromptForm(true);
                        }}
                      >
                        {item.name}
                      </p>
                      <div
                        className="size-18px bg-[rgba(0,0,0,.3)] hover:bg-[rgba(0,0,0,.5)] rounded-full flex justify-center items-center cursor-pointer absolute right-[-10px] top-[-10px] delete"
                        onClick={() => {
                          store.prompt_form.splice(index, 1);
                        }}
                      >
                        <SVGPureIcon
                          name="close-8"
                          className="text-[#fff]"
                          size={8}
                        />
                      </div>
                    </div>
                  );
                })}
                <div
                  className="w-200px custom-boxhover h-40px border-dashed rounded-8px px-12px border-1px border-black bg-white  cursor-pointer mb-10px flex justify-center items-center"
                  onClick={() => {
                    store.setFormId('');
                    store.setVisiblePromptForm(true);
                  }}
                >
                  <SVGPureIcon name="plus" className="text-[#000]" size={14} />
                </div>
              </div>
            </Form.Item>
          </div>
        </div>
      </div>
    </div>
  );
});

export default FormMain;
